import { OrderStatus } from '../api/orderApi';

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

const getStatusInfo = (status: OrderStatus) => {
  switch (status) {
    case OrderStatus.New:
      return {
        label: 'Новый',
        color: 'bg-blue-100 text-blue-800 border-blue-200'
      };
    case OrderStatus.Processing:
      return {
        label: 'В обработке',
        color: 'bg-yellow-100 text-yellow-800 border-yellow-200'
      };
    case OrderStatus.Shipping:
      return {
        label: 'В доставке',
        color: 'bg-purple-100 text-purple-800 border-purple-200'
      };
    case OrderStatus.Delivered:
      return {
        label: 'Доставлен',
        color: 'bg-green-100 text-green-800 border-green-200'
      };
    case OrderStatus.Cancelled:
      return {
        label: 'Отменен',
        color: 'bg-red-100 text-red-800 border-red-200'
      };
    default:
      return {
        label: 'Неизвестно',
        color: 'bg-gray-100 text-gray-800 border-gray-200'
      };
  }
};

export default function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  const statusInfo = getStatusInfo(status);

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${statusInfo.color}`}>
      {statusInfo.label}
    </span>
  );
}
